import {useEffect} from 'react';

import {useGetAutoDeliveryDetailsExtendedDcx} from '@/api/consumerApi';
import AppLoader from '@/components/Loader/AppLoader/AppLoader';
import {AUTO_DELIVERY_DCX_STATUS_TYPES, AutoDeliveryDcxStatus} from '@/consts/icc/iccAutoDeliveryStatusTypes';
import routerService from '@/services/route/routerService';

import {useAutoDeliveryDcxContext} from './AutoDeliveryDcxContext';
import StatusActive from './AutoDeliveryDcxDetailsPages/StatusActive/StatusActive';
import StatusOnHold from './AutoDeliveryDcxDetailsPages/StatusOnHold/StatusOnHold';

const getAutoDeliveryDcxDetailsComponent = (status: AutoDeliveryDcxStatus) => {
    switch (status) {
        case AUTO_DELIVERY_DCX_STATUS_TYPES.ACTIVE:
            return StatusActive;
        case AUTO_DELIVERY_DCX_STATUS_TYPES.ON_HOLD:
            return StatusOnHold;
        default:
            return null;
    }
};

const AutoDeliveryDcxPage = () => {
    const {detailsRefetchDisabled, setDetailsRefetchDisabled} = useAutoDeliveryDcxContext();

    useEffect(() => {
        if (detailsRefetchDisabled) setDetailsRefetchDisabled(false);
    }, []);

    const {data, isLoading, isFetching, isError} = useGetAutoDeliveryDetailsExtendedDcx({
        refetchOnMountOrArgChange: !detailsRefetchDisabled,
    });

    // @ts-expect-error AppLoader is a JS component without proper type definitions
    if (!data) return <AppLoader />;
    if (isError) {
        routerService.goBack();
        return null;
    }

    const {
        autoDelivery: {status},
    } = data;

    const AutoDeliveryDcxDetailsComponent = getAutoDeliveryDcxDetailsComponent(status);

    if (!AutoDeliveryDcxDetailsComponent) {
        routerService.goBack();
        return null;
    }

    return (
        <>
            {/* @ts-expect-error */}
            {(isLoading || isFetching) && <AppLoader />}
            <AutoDeliveryDcxDetailsComponent />
        </>
    );
};

export default AutoDeliveryDcxPage;
